<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" style="overflow-x:hidden;">
			<div class="divider"></div>
			<div class="info-content single-content">
				<div  class="fill">
					<img alt="ממשו את התשוקה שלכם למוסיקה" :key=img2srcD :src=img2srcD class="fillImgBack" >
				<transition   name="fade" mode="out-in">
					<img alt="תנו לנו לדאוג לכל הפרטים" :key=img2src :src=img2src  class="fillImgFront" >
				</transition>
				</div>
				<div class="textbox-bounds double-textbounds">
					<div class="textbox textbox-right">
						<div class="textbox-tab-mark""></div>
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h3 role="heading" aria-level="2" v-html="texts.home_text1header"></h3>
								<p  v-html="texts.home_text1"></p>
							</div>
							<div class="text-box-paragraph">
								<h3 v-html="texts.home_text2header"></h3>
								<p v-html="texts.home_text2"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br>
			<div class="info-content single-content">

				<div   class="fill">
					<img  alt="אתם בידיים טובות" :key=img3srcD :src=img3srcD  class="fillImgBack" >
					<transition   name="fade" mode="out-in">
						<img  alt="הגיע הזמן להוציא את הגיטרה מהארון" :key=img3src :src=img3src  class="fillImgFront" >
					</transition>
				</div>
				<div class="textbox-bounds double-textbounds">
					<div class="textbox textbox-left double-textbounds">
						<div class="textbox-tab-mark"></div>
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h3 v-html="texts.home_text3header"></h3>
								<p v-html="texts.home_text3"></p>
							</div>
							<div class="text-box-paragraph">
								<h3 v-html="texts.home_text4header"></h3>
								<p v-html="texts.home_text4"></p>
							</div>
							<div class="text-box-paragraph">
								<v-link href="/rhythm">
								<img alt="רישום לאודישן" src="images/comeplay.png" />
								</v-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="divider"></div>
			<div id="someAnnoyingDiv" class="info-content single-content textbox-bounds-unbound">
				<div  class="fill">
					<img alt="לנגן בלהקה או לשיר במקהלה?" :key=img5srcD :src=img5srcD  class="fillImgBack" >
					<transition   name="fade" mode="out-in">
						<img alt="לנגן בלהקה או לשיר במקהלה?" :key=img5src :src=img5src  class="fillImgFront" >
					</transition>
				</div>
				<div class="textbox-bounds-unbound">
					<div class="textbox single-content textbox-left embedVideoMargin">
						<div class="textbox-tab-mark"></div>
						<div class="textbox-text">
							<div class="text-box-paragraph">
								<h3 v-html="texts.home_text5header"></h3>
								<p v-html="texts.home_text5"></p>
							</div>
						</div>
					</div>
					<div   class="embeded-player single-content" >
						<div id="embeded-player" >

<div class="plyr__video-embed" id="player2">
    <iframe src="https://www.youtube.com/embed/videoseries?list=PLkEmjSM87aKrcl-z0EZgvQwPHiITsp9Vb&autoplay=0&iv_load_policy=3&modestbranding=0&playsinline=1showinfo=0&rel=0&enablejsapi=1?&autohide=1&controls=1&mute=0&origin=https://yardbands.com" allowfullscreen allowtransparency style="position:absolute;z-index: 8;" id="yuPlayer2"></iframe>
</div>
						</div>
					</div>
				</div>
			</div>
			<div class="divider"></div>
			<div class="info-content double-content">
			<div   class="fill double-content">
				<img alt="איך זה עובד?" :key=img6srcD :src=img6srcD  class="fillImgBack" >
				<transition   name="fade" mode="out-in">
					<img alt="איך זה עובד?" :key=img6src :src=img6src  class="fillImgFront" >
				</transition>
			</div>
			<div class="textbox-bounds double-textbounds">
				<div class="textbox textbox-left textbox-centerlized">
					<div class="textbox-tab-mark"></div>
					<div class="textbox-text centered">
							<h3 id="working" v-html="texts.home_text6header"></h3>
							<div class="text-box-paragraph bordered">
								<h3 v-html="texts.home_text6subheader"></h3>
								<p v-html="texts.home_text6_1"></p>
							</div>
							<div class="downward-arrow"></div>
							<div class="text-box-paragraph bordered">
								<h3 v-html="texts.home_text6subheader2"></h3>
								<p v-html="texts.home_text6_2"></p>
							</div>
							<div class="downward-arrow"></div>
							<div class="text-box-paragraph bordered">
								<h3 v-html="texts.home_text6subheader3"></h3>
								<p v-html="texts.home_text6_3"></p>
							</div>
							<div class='comeplay-btn'>
								<v-link href="/rhythm">
								<img alt="רישום לאודישן" src="images/comeplay.png" />
								</v-link>
							</div>
					
					</div>
				</div>
			</div>
			</div>
			<div class="divider"></div>
			<div id="FAQS" class="info-content double-content2">
				<div   class="fill double-content2">
					<img alt="שאלות נפוצות" :key=img8srcD :src=img8srcD  class="fillImgBack" >
					<transition name="fade" mode="out-in">
						<img alt="שאלות נפוצות" :key=img8src :src=img8src  class="fillImgFront" >
					</transition>
				</div>
				<div class="textbox-bounds double-textbounds">
				<div class="textbox textbox-right">
					<div class="textbox-tab-mark"></div>
					<div class="textbox-text">
						<div class="text-box-paragraph">
							<h3>שאלות נפוצות</h3>

							<transition name="fade" mode="out-in">
						<FAQ :key="faq"></FAQ>
					</transition>
						</div>
					</div>
				</div>
			</div>
		</div>


		</section>
  </main-layout>
</template>

<script>
import axios from 'axios'
  import MainLayout from '../layouts/Main.vue'
  import VLink from '../components/VLink.vue'
  import TalkToMeHeader from '../components/TalkToMeHeader.vue'
  import FAQ from '../components/FAQ.vue'
  var APIbase = "https://yard-bands.herokuapp.com"
  export default {
    components: {
      MainLayout,FAQ,VLink,TalkToMeHeader
    },
	created () {
		this.language = window.navigator.language;
		this.auditionButtonOpen=false;
		this.img2src = this.img2List[Math.floor(Math.random() * this.img2List.length)]
		this.img3src = this.img3List[Math.floor(Math.random() * this.img3List.length)]
		this.img5src = this.img5List[Math.floor(Math.random() * this.img5List.length)]
		this.img6src = this.img6List[Math.floor(Math.random() * this.img6List.length)]
		//this.img7src = list[Math.floor(Math.random() * list.length)]
		//this.img8src = list[Math.floor(Math.random() * list.length)]
		this.img2srcD=""+this.img2src
	    this.img3srcD=""+this.img3src
	    this.img5srcD=""+this.img5src
		this.img6srcD=""+this.img6src
	    this.img7srcD=""+this.img7src
	    this.img8srcD=""+this.img8src
		this.SetImgInterval("img2src",this.img2List,0)
		this.SetImgInterval("img3src",this.img3List,10000)
		this.SetImgInterval("img5src",this.img5List,15000)
		this.SetImgInterval("img6src",this.img6List,25000)
		window.addEventListener('resize',this.windowResized);
		this.windowResized();
		this.texts = {}
		this.fetchHomeLabels();
	},
	destroyed(){
		window.removeEventListener('resize',this.windowResized);
	},
	data() {
		return {
			img2srcD:'',
			img3srcD:'',
			img5srcD:'',
			img6srcD:'',
			img7srcD:'',
			img8srcD:'',
			img2src: 'photos/container02/c02_01.jpg',
			img3src: 'photos/container03/c03_01.jpg',
			img5src: 'photos/container05/c05_01.jpg',
			img6src: 'photos/container06/c06_01.jpg',
			img7src: 'photos/container07/c07_01.jpg',
			img8src: 'photos/container08/c08_01.jpg',
			img2List : ["photos/container02/c02_01.jpg","photos/container02/c02_02.jpg","photos/container02/c02_03.jpg","photos/container02/c02_04.jpg","photos/container02/c02_05.jpg","photos/container02/c02_06.jpg","photos/container02/c02_07.jpg"],
			img3List : ["photos/container03/c03_01.jpg","photos/container03/c03_02.jpg","photos/container03/c03_03.jpg","photos/container03/c03_04.jpg"],
			img5List : ["photos/container05/c05_01.jpg","photos/container05/c05_02.jpg"],
			img6List : ["photos/container06/c06_01.jpg","photos/container06/c06_02.jpg"],
			flexibleHeight: 700,
			flexibleWidth: 1000
		}
	},
	methods: {
		fetchHomeLabels() {
			axios.get(APIbase+'/home_text').then(response => {
				this.texts = response.data;
				this.$forceUpdate();
			})
		},
		windowResized() {
			console.log(this.flexibleHeight);
			this.flexibleHeight= Math.min(window.innerWidth * 3/4,700);
			this.flexibleWidth =  Math.min(window.innerWidth-100,1000);
		},
		SetImgInterval(imgID,list,offset) {
			if (offset > 0) {
				setTimeout(function() {
					this.SetImgInterval(imgID,list,0)
				}.bind(this),offset);
			}
			else {
				setInterval(function(){
						var tmp = new Image();
						var newsrc = list[((list.indexOf(this[imgID]) + 1) % list.length)];
						tmp.src = newsrc
						tmp.onload = function(event) {
							this[imgID] = newsrc;
							setTimeout(function() {
								this[imgID+"D"] = newsrc;
							}.bind(this),5000);
						}.bind(this);
				}.bind(this), 30000);
			}
		}



	}

  }
</script>



// WEBPACK FOOTER //
// Home.vue?5f0cd612